export default __webpack_public_path__ + "static/media/Arch_Amazon-RDS_64.c4bfb4a6.svg";